import type { FC } from 'react';
import type { SimilarProducts as SimilarProductsType } from '../../../../@types/gql/product-detail';
import ProductCard from '../../categories/products/card';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SimilarProducts: FC<{ similarProducts: SimilarProductsType }> = ({
  similarProducts,
}) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  
  return (
    <div className="pb-28">
      <div className="bg-gray-200 h-2 w-full my-10 mt-20" />
      <div className="container mx-auto px-6">
        <p className="mb-6 text-3xl font-bold">Similar Products</p>
        <Slider {...settings}>
          {similarProducts.nodes?.map(
            ({ id, Description, Slug, Thumbnail, Title, subCategory }) => {
              if (!subCategory) {
                return null;
              }
              return (
                <div className="min-w-72 max-w-72" key={id}>
                  <ProductCard
                    description={Description}
                    href={`/${subCategory.Category.Slug}/${subCategory.Slug}/${Slug}`}
                    image={Thumbnail.url}
                    name={Title}
                  />
                </div>
              );
            },
          )}
        </Slider>
      </div>
    </div>
  );
};

export default SimilarProducts;
